export const FETCH_CALCULATOR_CONFIG = 'roiCalculator/fetchCalculatorConfig';
export const FETCH_CALCULATOR_CONFIG_START = 'roiCalculator/fetchCalculatorConfigStart';
export const FETCH_CALCULATOR_CONFIG_COMPLETE = 'roiCalculator/fetchCalculatorConfigComplete';
export const FETCH_CALCULATOR_CONFIG_ERROR = 'roiCalculator/fetchCalculatorConfigError';

export const CALCULATE_RESULTS = 'roiCalculator/calculateResults';
export const CALCULATE_RESULTS_START = 'roiCalculator/calculateResultsStart';
export const CALCULATE_RESULTS_COMPLETE = 'roiCalculator/calculateResultsComplete';
export const CALCULATE_RESULTS_ERROR = 'roiCalculator/calculateResultsError';

export const CLEAR_CALCULATOR_ERROR = 'roiCalculator/clearCalculatorError';

export const fetchCalculatorConfig = (payload = {}) => ({
  type: FETCH_CALCULATOR_CONFIG,
  payload,
});

export const calculateResults = (payload = {}) => ({
  type: CALCULATE_RESULTS,
  payload,
});

export const clearCalculatorError = (payload = {}) => ({
  type: CLEAR_CALCULATOR_ERROR,
  payload,
});
